export const createCsvFile = (data: string, filename: string) => {
    const csvData = encodeURI(`data:text/csv;charset=utf-8,${data}`);
    const link = document.createElement('a');
    link.setAttribute('href', csvData);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
